import { useState, useCallback } from 'react';

export function useFilters<T extends Record<string, unknown>>(defaultFilters: T) {
  const [filters, setFilters] = useState<T>(defaultFilters);

  const updateFilter = useCallback(<K extends keyof T>(key: K, value: T[K]) => {
    setFilters((prev) => {
      const next = { ...prev, [key]: value };
      if (key !== 'page' && 'page' in prev) {
        (next as Record<string, unknown>).page = 1;
      }
      return next;
    });
  }, []);

  const resetFilters = useCallback(() => setFilters(defaultFilters), [defaultFilters]);

  const setAllFilters = useCallback((newFilters: Partial<T>) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  }, []);

  return { filters, updateFilter, resetFilters, setAllFilters };
}
